import styled, { css, keyframes } from "styled-components";

export const ContainerProd = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #585e66;
  box-shadow: 0px 0.27rem 0.8rem rgba(88, 94, 102, 0.18);
  border-radius: 0.4rem;
  user-select: none;
`;

export const LeftSide = styled.div`
  width: 43%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const LeftTitle = styled.span`
  align-self: center;
  margin-top: 1.5rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.94rem;
  line-height: 1.48rem;

  color: #eff1f5;
`;

export const BodySeparator = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 90%;
  width: 100%;
`;

export const Toggle = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 1.75rem;
  width: 80%;
  justify-content: space-evenly;

  //Old Organization
  /*margin-left: 3rem;
  margin-top: 0.8rem;*/
`;
export const ToggleAnimation = styled.div`
  position: absolute;
  height: 100%;
  border-radius: 0.4rem;
  background: linear-gradient(
    to left,
    rgba(64, 229, 160, 0.34) 0.14%,
    rgba(66, 70, 76, 0) 160.14%
  );
  width: ${({ toggleState }) =>
    toggleState === "Geral"
      ? "22.5%"
      : toggleState === "Semanal"
      ? "28.5%"
      : "27%"};
  left: ${({ toggleState }) =>
    toggleState === "Geral"
      ? "5%"
      : toggleState === "Semanal"
      ? "33.5%"
      : "68%"};
  pointer-events: none;
  z-index: 1;
  transition: 0.2s ease-out;
`;

export const ToggleGeral = styled.span`
  padding-left: 1rem;
  padding-right: 1rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  cursor: pointer;

  color: ${({ toggleState }) =>
    toggleState === "Geral" ? "#40e5a0" : "#A9AEB4;"};
`;

export const ToggleSemanal = styled.span`
  // margin-left: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  cursor: pointer;

  color: ${({ toggleState }) =>
    toggleState === "Semanal" ? "#40e5a0" : "#A9AEB4;"};
`;

export const ToggleMensal = styled.span`
  //margin-left: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  cursor: pointer;

  color: ${({ toggleState }) =>
    toggleState === "Mensal" ? "#40e5a0" : "#A9AEB4;"};
`;

export const Speedometer1 = styled.div`
  // margin-top: 0.6rem;
  // margin-left: 3rem;
  border-top-left-radius: 8rem;
  border-top-right-radius: 8rem;
  height: 8rem;
  width: 16rem;
  background: conic-gradient(
    from 270deg at 50% 100%,
    #e62525 0deg,
    #f0904b 38.44deg,
    #f5e86b 92.81deg,
    #40e5a0 143.44deg,
    #21a175 180deg
  );
  border-bottom: 0;
  position: relative;
`;

export const SpeedometerBackground = styled.div`
  position: absolute;
  bottom: -0.5rem;
  left: 1.5rem;
  width: 13rem;
  height: 7rem;
  border-top-left-radius: 7rem;
  border-top-right-radius: 7rem;
  background-color: #585e66;
`;

export const Speedometerdots = styled.div`
  position: absolute;
  bottom: 0;
  left: 2.25rem;
  width: 11.5rem;
  height: 5.75rem;
  border-top-left-radius: 6rem;
  border-top-right-radius: 6rem;
  border: 4px dotted whitesmoke;
  border-bottom: 0;
`;

export const SpeedometerDashes1 = styled.div`
  position: absolute;
  bottom: -0.025rem;
  left: 2.25rem;
  width: 0.5rem;
  border-top: 0.1rem solid whitesmoke;
`;
export const SpeedometerDashes2 = styled.div`
  position: absolute;
  bottom: -0.025rem;
  right: 2.25rem;
  width: 0.5rem;
  border-top: 0.1rem solid whitesmoke;
`;
export const SpeedometerDashes3 = styled.div`
  position: absolute;
  top: 2.25rem; //-0.025rem;
  right: 7.975rem;
  height: 0.5rem;
  border-right: 0.1rem solid whitesmoke;
`;

export const SpeedometerValue1 = styled.span`
  position: absolute;
  height: 1rem;
  bottom: -0.5rem;
  left: 2.85rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #ffffff;
`;
export const SpeedometerValue2 = styled.span`
  position: absolute;
  height: 1rem;
  bottom: -0.5rem;
  right: 2.85rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #ffffff;
`;

export const SpeedometerValue3 = styled.span`
  display: flex;
  width: 2rem;
  justify-content: center;
  position: absolute;
  top: 2.85rem;
  right: 7rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #ffffff;
`;

export const SpeedomenterSuportBase = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 100%;
  background-color: #7e858f;
  position: absolute;
  left: 7.1rem;
  bottom: -0.9rem;
`;

export const SpeedometerPointer = styled.div`
  width: 5.9rem;
  height: 0.75rem;
  position: absolute;
  left: 8rem;
  bottom: 0rem;
  transform-origin: 0.45rem 50%;
  overflow: hidden;
  animation: ${({ animation, animationDuration }) =>
    animation === "01"
      ? "rotation01  1.5s 1 linear"
      : animation === "12"
      ? "rotation12 " + animationDuration + " 1 linear"
      : animation === "13"
      ? "rotation13 " + animationDuration + " 1 linear"
      : animation === "21"
      ? "rotation21 " + animationDuration + " 1 linear"
      : animation === "23"
      ? "rotation23 " + animationDuration + " 1 linear"
      : animation === "31"
      ? "rotation31 " + animationDuration + " 1 linear"
      : animation === "32"
      ? "rotation32 " + animationDuration + " 1 linear"
      : null};

  @keyframes rotation01 {
    0% {
      transform: translate(-0.45rem, 0.375rem) rotate(-180deg);
    }
    /* 50% {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + (pointerGeral + 10) + "deg)"};
    }
    70% {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + (pointerGeral - 5) + "deg)"};
    }
    85% {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + (pointerGeral + 2) + "deg)"};
    }*/
    100% {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + pointerGeral + "deg)"};
    }
  }
  @keyframes rotation12 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + pointerGeral + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerSemanal }) => "rotate(" + pointerSemanal + "deg)"};
    }
  }
  @keyframes rotation13 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + pointerGeral + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerMensal }) => "rotate(" + pointerMensal + "deg)"};
    }
  }
  @keyframes rotation21 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerSemanal }) => "rotate(" + pointerSemanal + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + pointerGeral + "deg)"};
    }
  }
  @keyframes rotation23 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerSemanal }) => "rotate(" + pointerSemanal + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerMensal }) => "rotate(" + pointerMensal + "deg)"};
    }
  }
  @keyframes rotation31 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerMensal }) => "rotate(" + pointerMensal + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerGeral }) => "rotate(" + pointerGeral + "deg)"};
    }
  }
  @keyframes rotation32 {
    from {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerMensal }) => "rotate(" + pointerMensal + "deg)"};
    }
    to {
      transform: translate(-0.45rem, 0.375rem)
        ${({ pointerSemanal }) => "rotate(" + pointerSemanal + "deg)"};
    }
  }

  transform: translate(-0.45rem, 0.375rem)
    ${({ animation, pointerGeral, pointerSemanal, pointerMensal }) =>
      animation === "01"
        ? "rotate(" + pointerGeral + "deg)"
        : animation === "12"
        ? "rotate(" + pointerSemanal + "deg)"
        : animation === "13"
        ? "rotate(" + pointerMensal + "deg)"
        : animation === "21"
        ? "rotate(" + pointerGeral + "deg)"
        : animation === "23"
        ? "rotate(" + pointerMensal + "deg)"
        : animation === "31"
        ? "rotate(" + pointerGeral + "deg)"
        : animation === "32"
        ? "rotate(" + pointerSemanal + "deg)"
        : null};
`;

export const SpeedometerPointerBase = styled.div`
  width: 100%;
  height: 100%;
  left: 8rem;
  bottom: 0rem;
  transform-origin: 5% 50%;
  transform: skewY(-2deg);
  overflow: hidden;
  border-bottom-left-radius: 0.45rem;
  border-bottom-right-radius: 0.3rem;
`;

export const SpeedometerPointerTop = styled.div`
  width: 100%;
  height: 100%;
  transform-origin: 5% 50%;
  transform: skewY(4deg);
  overflow: hidden;
  border-top-left-radius: 0.45rem;
  border-top-right-radius: 0.3rem;
  background-color: #ffffff;
`;

export const SpeedometerPointerPin = styled.div`
  width: 0.4rem;
  height: 0.4rem;
  background-color: #40e5a0;
  border-radius: 100%;
  position: absolute;
  left: 7.8rem;
  bottom: -0.2rem;
`;

export const SpeedometerMainDash = styled.div`
  width: 2rem;
  height: 0.1rem;
  background-color: #fff;
  position: absolute;
  left: -0.3rem;
  bottom: 0rem;
  transform-origin: 8.27rem 0.05rem;

  animation: ${({ animation, animationDuration }) =>
    animation === "01"
      ? "Dash01  1.5s 1 linear"
      : animation === "12"
      ? "Dash12 " + animationDuration + " 1 linear"
      : animation === "13"
      ? "Dash13 " + animationDuration + " 1 linear"
      : animation === "21"
      ? "Dash21 " + animationDuration + " 1 linear"
      : animation === "23"
      ? "Dash23 " + animationDuration + " 1 linear"
      : animation === "31"
      ? "Dash31 " + animationDuration + " 1 linear"
      : animation === "32"
      ? "Dash32 " + animationDuration + " 1 linear"
      : null};

  @keyframes Dash01 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: ${({ pointerGeral }) =>
        "rotate(" + (180 + pointerGeral) + "deg)"};
    }
  }
  @keyframes Dash12 {
    from {
      transform: ${({ pointerGeral }) =>
        "rotate(" + (180 + pointerGeral) + "deg)"};
    }
    to {
      transform: ${({ pointerSemanal }) =>
        "rotate(" + (180 + pointerSemanal) + "deg)"};
    }
  }
  @keyframes Dash13 {
    from {
      transform: ${({ pointerGeral }) =>
        "rotate(" + (180 + pointerGeral) + "deg)"};
    }
    to {
      transform: ${({ pointerMensal }) =>
        "rotate(" + (180 + pointerMensal) + "deg)"};
    }
  }
  @keyframes Dash21 {
    from {
      transform: ${({ pointerSemanal }) =>
        "rotate(" + (180 + pointerSemanal) + "deg)"};
    }
    to {
      transform: ${({ pointerGeral }) =>
        "rotate(" + (180 + pointerGeral) + "deg)"};
    }
  }
  @keyframes Dash23 {
    from {
      transform: ${({ pointerSemanal }) =>
        "rotate(" + (180 + pointerSemanal) + "deg)"};
    }
    to {
      transform: ${({ pointerMensal }) =>
        "rotate(" + (180 + pointerMensal) + "deg)"};
    }
  }
  @keyframes Dash31 {
    from {
      transform: ${({ pointerMensal }) =>
        "rotate(" + (180 + pointerMensal) + "deg)"};
    }
    to {
      transform: ${({ pointerGeral }) =>
        "rotate(" + (180 + pointerGeral) + "deg)"};
    }
  }
  @keyframes Dash32 {
    from {
      transform: ${({ pointerMensal }) =>
        "rotate(" + (180 + pointerMensal) + "deg)"};
    }
    to {
      transform: ${({ pointerSemanal }) =>
        "rotate(" + (180 + pointerSemanal) + "deg)"};
    }
  }

  transform: ${({ animation, pointerGeral, pointerSemanal, pointerMensal }) =>
    animation === "01"
      ? "rotate(" + (180 + pointerGeral) + "deg)"
      : animation === "12"
      ? "rotate(" + (180 + pointerSemanal) + "deg)"
      : animation === "13"
      ? "rotate(" + (180 + pointerMensal) + "deg)"
      : animation === "21"
      ? "rotate(" + (180 + pointerGeral) + "deg)"
      : animation === "23"
      ? "rotate(" + (180 + pointerMensal) + "deg)"
      : animation === "31"
      ? "rotate(" + (180 + pointerGeral) + "deg)"
      : animation === "32"
      ? "rotate(" + (180 + pointerSemanal) + "deg)"
      : null};
`;

export const HoverBox = styled.span`
  z-index: 5;
  width: 4rem;
  height: 2rem;
  background: ${({
    BoxXGeral,
    BoxXSemanal,
    BoxXMensal,
    toggleState,
    BoxYGeral,
    BoxYSemanal,
    BoxYMensal,
  }) =>
    toggleState === "Geral"
      ? "conic-gradient(from 270deg at " +
        BoxXGeral +
        "rem " +
        BoxYGeral +
        "rem,#e62525 0deg,#f0904b 38.44deg,#f5e86b 92.81deg,#40e5a0 143.44deg,#21a175 180deg,#21a175 230deg,#e62525 320deg)"
      : toggleState === "Semanal"
      ? "conic-gradient(from 270deg at " +
        BoxXSemanal +
        "rem " +
        BoxYSemanal +
        "rem,#e62525 0deg,#f0904b 38.44deg,#f5e86b 92.81deg,#40e5a0 143.44deg,#21a175 180deg,#21a175 230deg,#e62525 320deg)"
      : toggleState === "Mensal"
      ? "conic-gradient(from 270deg at " +
        BoxXMensal +
        "rem " +
        BoxYMensal +
        "rem,#e62525 0deg,#f0904b 38.44deg,#f5e86b 92.81deg,#40e5a0 143.44deg,#21a175 180deg,#21a175 230deg,#e62525 320deg)"
      : null};

  position: absolute;
  left: 6rem;
  bottom: -1rem;
  transform: ${({
    BoxXGeral,
    BoxXSemanal,
    BoxXMensal,
    toggleState,
    BoxYGeral,
    BoxYSemanal,
    BoxYMensal,
  }) =>
    toggleState === "Geral"
      ? "translate(" + -BoxXGeral + "rem, " + -BoxYGeral + "rem)"
      : toggleState === "Semanal"
      ? "translate(" + -BoxXSemanal + "rem, " + -BoxYSemanal + "rem)"
      : toggleState === "Mensal"
      ? "translate(" + -BoxXMensal + "rem, " + -BoxYMensal + "rem)"
      : null};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
`;

export const HoverBoxText = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.34rem;
  line-height: 1.7rem;
  text-align: center;
  color: #42464c;
`;

export const LeftBottomText = styled.span`
  //margin-left: 8.75rem;
  width: 5rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  text-align: center;
  letter-spacing: 0.05em;

  color: #eff1f5;
`;

export const SeparatorSection = styled.div`
  width: 2px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #7e858f;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const InvisibleBlocks = styled.div`
  background-color: #585e66;
  width: 2px;
  height: ${({ height }) => height};
  top: ${({ top }) => top};
  position: absolute;
`;

export const RightSide = styled.div`
  width: 57%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const RightHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 3rem;
  box-sizing: border-box;
  position: relative;
`;

export const RefreshContainer = styled.div`
  position: absolute;
  right: 1rem;
  top: 1rem;
`;

export const RightTitle = styled.span`
  margin-top: 1.5rem;
  align-self: center;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.94rem;
  line-height: 1.48rem;

  color: #eff1f5;
`;

export const RightSideBody = styled.div`
  height: 90%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RightLine = styled.div`
  height: 65%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 40%;
`;

export const MiniBlock = styled.div`
  height: 35%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const BoxTitle = styled.span`
  display: flex;
  justify-content: center;
  text-align: center;

  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #a9aeb4;
`;

export const DelayedTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;

  color: #f77d7d;
`;

export const PendingTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;
  color: #eff1f5;
`;

export const ExecutionTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;
  color: #f8e47c;
`;

export const ConcludedTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;
  color: #68db65;
`;

export const NonDelegatedTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;
  color: #eff1f5;
`;

export const DelayedConcludedTasks = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.52rem;
  text-align: center;
  letter-spacing: 0.05em;

  color: #68db65;
  text-shadow: 0px 0px 5px #f34f4f;
`;
